export const ROUTE_PATHS = {
  LANDING_PAGE: "/",
  INQUIRE_PAGE: "/inquire",
  REGISTER_PAGE: "/register",
  PAYMENT_RESULT_PAGE: "/payment-result",
  QUEUE_PAGE: "/queue",
  SPECIAL_EVENT_PAGE: "/special-event",
  SUBSCRIPTION_PAYMENT_HISTORY_PAGE: "/subscription-payment-history/:token",
  RECEIPT_LIST_PAGE: "/receipt-list",
  TEST_PAGE: "/testing",
};
